<template>
  <component
    :is="currentLoginComponent"
    :has-close-button="hasCloseButton"
    @login:success="$emit('login:success')"
    @close:loginmodal="$emit('close:loginmodal')"
    @change:emaillogin="switchToLoginForm"
    @show:showloginoptions="switchToLoginOptions"
  />
</template>

<script>
import LoginEmailModal from '@components/Modals/LoginEmailModal.vue'
import { computed, ref } from 'vue'

export default {
  components: {
    LoginEmailModal,
  },
  props: {
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close:loginmodal', 'login:success'],
  setup() {
    const currentLogin = ref('LoginEmailModal')
    const currentLoginComponent = computed(() => currentLogin.value)

    function switchToLoginForm() {
      currentLogin.value = 'LoginEmailModal'
    }

    function switchToLoginOptions() {
      //currentLogin.value = 'LoginOptionsModal'
    }

    return {
      currentLoginComponent,
      switchToLoginOptions,
      switchToLoginForm,
    }
  },
}
</script>
